import { FC, useEffect } from "react";
import Typography from "@/components/Typography";
import { useSearchJobsQuery, JobType, JOB_STATUS } from "@/fetch/suppliers";
import { Skeleton } from "@/components/Loader";
import { EmptyJobsList } from "@/components/EmptyList";
import { useTrackers, useLock, useFeatureFlags, useTripType } from "@/hooks";
import JobCard from "./JobCard";
import ExternalJobCard from "./ExternalJobCard";
import styles from "./SavedTab.module.scss";

const PAGE_SIZE = 30;

type Props = {
  //
};

const SavedTab: FC<Props> = () => {
  const {
    flags: { replaceWHJobsWithSLJobs },
  } = useFeatureFlags();
  const {
    data: jobsData,
    isLoading,
    refetch,
  } = useSearchJobsQuery(
    {
      page: 1,
      limit: PAGE_SIZE,
      isSaved: true,
      traits: replaceWHJobsWithSLJobs ? "30DaysOrMorePastArrival" : undefined,
    },
    replaceWHJobsWithSLJobs ? "&_cb[op]==&_cb[value]=16" : ""
  );
  const { isSuperliteTrip, isWHArrivalOnly } = useTripType();
  const { track } = useTrackers();

  useEffect(() => {
    track("Saved Tab Viewed", {
      eventId: "saved-tab-viewed",
    });
  }, []);

  const savedJobs = [...(jobsData?.data || [])].sort((firstJob, secondJob) => {
    if (
      firstJob.status === JOB_STATUS.Active &&
      secondJob.status !== JOB_STATUS.Active
    )
      return -1;
    if (
      firstJob.status !== JOB_STATUS.Active &&
      secondJob.status === JOB_STATUS.Active
    )
      return 1;
    return 0;
  });

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Skeleton
          height={213}
          variant="rectangular"
          className={styles.loader}
        />
      ) : (
        <>
          {savedJobs.length > 0 ? (
            <>
              <Typography variant="h6" className={styles.title}>
                Saved jobs
              </Typography>
              {savedJobs.map((eachJob) =>
                isSuperliteTrip || isWHArrivalOnly ? (
                  <ExternalJobCard
                    key={eachJob.id}
                    job={eachJob}
                    onSave={() => refetch()}
                  />
                ) : (
                  <JobCard
                    key={eachJob.id}
                    isOnSaveTab
                    job={eachJob}
                    onSave={() => refetch()}
                  />
                )
              )}
            </>
          ) : (
            <EmptyJobsList variant="saved" />
          )}
        </>
      )}
    </div>
  );
};

export default SavedTab;
